* {
  box-sizing: border-box;
}

.map-wrapper {
  display: flex;
  justify-content: center;
}
